import { KAPLAYCtx } from "kaplay";
import { CAMERA } from "./constants";
import type { Camera, Player } from "./types";

export function updateCamera(
  camera: Camera,
  player: Player,
  baselineY: number,
  canvasWidth: number,
  canvasHeight: number,
  dt: number,
): void {
  const playerToBaselineDistance = Math.abs(baselineY - player.y);

  const targetScale = Math.min(
    CAMERA.MIN_SCALE,
    (canvasHeight * CAMERA.VIEWPORT_HEIGHT_FACTOR) /
      Math.max(playerToBaselineDistance, CAMERA.MIN_PLAYER_BASELINE_DISTANCE),
  );

  camera.scale += (targetScale - camera.scale) * CAMERA.SCALE_SMOOTHING;

  const viewportWidth = canvasWidth / camera.scale;
  const targetCameraX =
    player.x - viewportWidth * CAMERA.PLAYER_SCREEN_POSITION;
  camera.x += (targetCameraX - camera.x) * CAMERA.POSITION_SMOOTHING;

  if (camera.shakeTime > 0) {
    camera.shakeTime -= dt;
    if (camera.shakeTime <= 0) {
      camera.shakeTime = 0;
      camera.shakeIntensity = 0;
      camera.initialShakeDuration = 0;
    }
  }
}

export function applyCameraTransform(
  k: KAPLAYCtx,
  camera: Camera,
  player: Player,
  baselineY: number,
): void {
  const viewportWidth = k.width() / camera.scale;
  const midY = (player.y + baselineY) / 2;

  let shakeX = 0;
  let shakeY = 0;
  if (camera.shakeTime > 0) {
    const shakeProgress = camera.shakeTime / camera.initialShakeDuration;
    const currentIntensity = camera.shakeIntensity * shakeProgress;
    shakeX = (Math.random() - 0.5) * 2 * currentIntensity;
    shakeY = (Math.random() - 0.5) * 2 * currentIntensity;
  }

  k.setCamPos(k.vec2(camera.x + viewportWidth / 2 + shakeX, midY + shakeY));
  k.setCamScale(k.vec2(camera.scale));
}
